// extracted by mini-css-extract-plugin
export default {"nameWrapper":"form-module__IG6rQ","form":"form-module__uLDVc","actions":"form-module__L_unA"};